import React, { useContext, useState } from "react";
import styles from "./Transfer.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { listenToTransactionStatus, makeid } from "../../../context/utils";
import { StatusMessage } from "../../StatusMessage";
import { BackToMethods } from "../../common/BackToMethods";
import { StatusContext } from "../../../context/Status";
import axios from "axios";
import { ErrorAlertContext } from "../../../context/ErrorAlert";
import { WalletPayProps } from "../Wallet";
import { Options } from "./Options";
import { Instructions } from "./Instructions";

export const CellulantMethod = () => {
  const { email, currency, amount, merchantKey, payData } =
    useContext(RoutingContext);
  const { onShowAlert } = useContext(ErrorAlertContext);
  const { setPageTransactionStatus } = useContext(StatusContext);

  const [isLoading, setIsLoading] = useState(false);
  const [transferDetails, setTransferDetails] = useState({});
  const [tabDisplayed, setTabDisplayed] = useState("details");
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [instruction, setInstruction] = useState("");
  const [cellTnxReference, setCellTnxReference] = useState("");

  const onPay = async (data?: WalletPayProps) => {
    setIsLoading(true);

    const uniqueAccKey = "uni" + makeid();

    const todaysDate = new Date();
    const todaysDay = todaysDate.getDate();
    const todaysMonth = todaysDate.getMonth() + 1;
    const todaysYear = todaysDate.getFullYear();
    const cellDueDate =
      todaysYear + "-" + todaysMonth + "-" + todaysDay + " 23:59:59";

    const cellulantObj = {
      amount,
      email: payData.kit?.email,
      phoneNumber: payData.kit?.phone_number
        ? payData?.kit?.phone_number?.replaceAll(/\s+/g, "")
        : "",
      country: "TZ",
      paymentType: payData.kit?.paymentType,
      currency: payData?.currency,
      firstName: data?.firstName,
      lastName: data?.Name,
      dueDate: cellDueDate,
      tx_ref: payData.kit?.tx_ref,
      accountNumber: uniqueAccKey,
      sourceCurrency: payData?.sourceCurrency,
      sourceAmount: payData.kit?.sourceAmount,
    };

    if (
      payData.kit.extra &&
      ["baepay", "baepayapp"].includes(payData.kit.extra)
    ) {
      // @ts-ignore
      cellulantObj.extra = "baepay";
      // @ts-ignore
      cellulantObj.baeEmail = payData.kit?.baeEmail;
    }

    try {
      const response = await axios(
        `${process.env.REACT_APP_API_URL}pay/TZS/mobilemoney`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
          },
          data: cellulantObj,
        }
      );
      const responseData = response.data;
      if (responseData.checkoutRequestID) {
        const cellulantPaymentOptions = responseData.paymentOptions;
        setPaymentOptions(cellulantPaymentOptions);
        // for(var i = 0; i < cellulantPaymentOptions.length; i++) {
        //     // TODO: filter by minimum and maximum
        //     const payOpt = cellulantPaymentOptions[i];
        //     jQuery("#cellulant-option-list").append("<label class='cell-opt-item'><div class='cell-opt-item-desc'><p class='cell-opt-item-title'>" + payOpt.payerClientName + "</p><p class='cell-opt-item-sub-title'>" + payOpt.paymentModeName + "</p></div><input id='" + payOpt.payerModeID + "' type='radio' name='cellulantRadioOpt' value='" + payOpt.payerModeID + "'><span class=\"checkmark\"></span></label>")
        // }
        const cellulantTransferReference = responseData.merchantTransactionID;
        setCellTnxReference(cellulantTransferReference);
        listenToTransactionStatus(
          cellulantTransferReference,
          setTabDisplayed,
          setPageTransactionStatus,
        );

        const cellulantChargeObj = {
          checkoutRequestID: responseData.checkoutRequestID,
          merchantTransactionID: responseData.merchantTransactionID,
          chargeMsisdn: payData.kit?.phone_number,
          requestAmount: responseData.requestAmount,
          originalCurrencyCode: "TZS",
        };
        setTransferDetails(cellulantChargeObj);
        setTabDisplayed("options");
      } else {
        onShowAlert(responseData, "Payment failed please try again");
      }
    } catch (err) {
      // @ts-ignore
      onShowAlert(err, err.response.data.message);
    }
    setIsLoading(false);
  };

  const onCellulantOption = async (bankOption: any) => {
    setIsLoading(true);

    try {
      const response = await axios(
        `${process.env.REACT_APP_API_URL}pay/TZS/mobilemoney/charge`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
          },
          data: transferDetails,
        }
      );
      const responseData = response.data;

      if (responseData.checkoutRequestID) {
        setTabDisplayed("instructions");
        setInstruction(responseData.paymentInstructions);
      } else {
        onShowAlert(responseData, "Payment failed please try again");
      }
    } catch (err) {
      // @ts-ignore
      onShowAlert(err, err.response.data.message);
    }
    setIsLoading(false);
  };

  const onPaid = () => {
    // cellTnxReference // TODO: use this to check
  };

  if (tabDisplayed === "error" || tabDisplayed === "success") {
    return <StatusMessage type={tabDisplayed} />;
  }

  return (
    <MobileWrapper>
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            {tabDisplayed === "details" && (
              <Details
                defaultPhone={payData.kit?.phone_number}
                onPay={onPay}
                isLoading={isLoading}
              />
            )}
            {tabDisplayed === "options" && (
              <Options
                paymentOptions={paymentOptions}
                onChange={onCellulantOption}
              />
            )}
            {tabDisplayed === "instructions" && (
              <Instructions instructions={instruction} onPaid={onPaid} />
            )}
          </div>
          <BackToMethods />
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
